// src/locales/en/messageCenterShiftTypes.js
export const messageCenterShiftTypes = {
  pageTitle: 'Message Center Shift Types',
  pageDescription: 'Manage shift types and their commission slabs',
  newShiftType: 'New Shift Type',
  editShiftType: 'Edit Shift Type',
  createShiftType: 'Create Shift Type',
  saveShiftType: 'Save Shift Type',
  name: 'Name',
  defaultTimes: 'Default Times',
  defaultStartTime: 'Default Start Time',
  defaultEndTime: 'Default End Time',
  commissionMethod: 'Commission Method',
  commissionMethodHelp: 'Only Per Sales Value is available today. Per Order and Per Items will be added later.',
  defaultTarget: 'Default Target',
  defaultTargetHelp: 'Default sales-value target applied to new shifts of this type.',
  perSalesValue: 'Per Sales Value',
  commissionSlabs: 'Commission Slabs',
  noSlabsConfigured: 'No slabs configured',
  addSlab: 'Add Slab',
  removeSlab: 'Remove',
  minValue: 'Min Value',
  maxValue: 'Max Value',
  rate: 'Rate (%)',
  openEnded: 'Open-ended',
  slabsHelp: 'The last slab must be open-ended (no max value). Slabs must not overlap.',
  failedToLoadShiftTypes: 'Failed to load shift types',
  shiftTypeCreatedSuccess: 'Shift type created successfully',
  shiftTypeUpdatedSuccess: 'Shift type updated successfully',
  failedToSaveShiftType: 'Failed to save shift type',
  noShiftTypesYet: 'No shift types yet',
  noShiftTypesYetDescription: 'Create your first shift type to get started',
  edit: 'Edit',
  activeHelp: 'Inactive shift types cannot be used for new shifts',
  placeholders: {
    name: 'e.g. Day Shift',
    selectTime: 'Select time',
    defaultTarget: 'e.g. 500000',
    firstMin: '0',
    nextMin: 'e.g. {value}',
    maxValue: 'e.g. 6000',
    rate: 'e.g. 1.5',
    fixedAmount: 'e.g. 5000',
  },
  validation: {
    nameRequired: 'Name is required',
    startTimeRequired: 'Default start time is required',
    endTimeRequired: 'Default end time is required',
    slabMinValueInvalid: 'Min value must be a valid non-negative number',
    slabRateInvalid: 'Rate must be a valid non-negative number',
    slabMaxValueRequired: 'Max value is required for every slab except the last',
    minNegative: 'Min value cannot be negative',
    maxNegative: 'Max value must be a valid non-negative number',
    wholeNumber: 'Use a whole number (no decimals)',
    maxRequired: 'Max value is required when another slab follows',
    maxGreater: 'Max value must be greater than min value',
    outOfOrder: 'Slabs must be in ascending order — this slab must start at {value}',
    gap: 'Slabs cannot have gaps — this slab must start at {value}',
    lastOpenEnded: 'The last (highest) slab must be open-ended — clear its max value',
    rateNegative: 'Value cannot be negative',
    rateRequired: 'Enter a valid non-negative value',
    rateMax: 'Rate cannot exceed 100%',
    fixErrors: 'Please fix the highlighted errors before saving',
  },
};
